export default __webpack_public_path__ + "static/media/1979.e6a55a6c.png";